/* eslint-disable no-eval */
import orderBy from 'lodash.orderby';
import groupBy from 'lodash.groupby';
import uniqBy from 'lodash.uniqby';

import formulaUtil from '../formula';
import { dataConstants } from '../../constants';
import { getPlotDataPoints } from '..';
import { getTimeDiff } from '../time';
import { escapeQuotes, getTradingData, isDefined } from '../../utils';

const getArrKeys = (data, type = dataConstants.CHART_TYPE.TIMESERIES) => {
  if (type === dataConstants.CHART_TYPE.TIMESERIES || type === dataConstants.CHART_TYPE.LIFESTORY || type === dataConstants.CHART_TYPE.STACKED) {
    const dateWiseData = groupBy(data, item => item.recordDate);
    const dates = Object.keys(dateWiseData).sort((a, b) => new Date(a) - new Date(b));
    return { data: dateWiseData, dataKeys: dates };
  }
  const seqWiseData = groupBy(data, item => item.seq);
  const seqs = Object.keys(seqWiseData).sort((a, b) => a - b);

  return { data: seqWiseData, dataKeys: seqs };
};

const getKey = (key, type = dataConstants.CHART_TYPE.TIMESERIES) =>
  type === dataConstants.CHART_TYPE.TIMESERIES || type === dataConstants.CHART_TYPE.LIFESTORY || type === dataConstants.CHART_TYPE.STACKED ? new Date(key) : +key;

export const evalExpression = (exp, data, chart = {}, type) => {
  // let dateWiseData = groupBy(data, item => item.recordDate);
  // let dates = Object.keys(dateWiseData).sort((a, b) => new Date(a) - new Date(b));

  let pData = data;
  const codeWiseData = groupBy(pData, it => it.code);



  const dataArr = getArrKeys(pData, type);

  let plottedData = [];
  const reg = /[A-Za-z\[\]]+/;
  const regX = new RegExp(reg);
  let squareItems = formulaUtil.getSquareItems(exp);

  if (squareItems && squareItems.length > 0) {
    squareItems = squareItems.map(d => {
      const item = codeWiseData && Object.keys(codeWiseData).length > 0 ? codeWiseData[d.code]?.find(it => (+it['recordDate'] || it['seq']) === +getKey(d.key, type)) : null;
      return ({ ...d, value: item ? item.value : null });
    });

    squareItems = squareItems.filter(d => d.value);

    squareItems.forEach(d => {
      exp = exp.replace(new RegExp(d.item.replace(/\[/g, '\\[').replace(/\]/g, '\\]'), 'g'), d.value);
    });
  }

  const tickers = formulaUtil.getSymbolCodes(exp, undefined, true);

  if (type === dataConstants.CHART_TYPE.TIMESERIES || type === dataConstants.CHART_TYPE.LIFESTORY || type === dataConstants.CHART_TYPE.STACKED) {
    pData = data?.map(d => ({ ...d, recordDate: d.recordDate ? new Date(d.recordDate) : d.recordDate }));
    let codeMax = [];

    Object.keys(codeWiseData).forEach(c => {
      codeMax.push(codeWiseData[c].min('recordDate'));
    });

    codeMax = codeMax.max('recordDate');

    Object.keys(codeWiseData).forEach(c => {
      if (c !== codeMax.code) {
        const closest = codeWiseData[c].filter(d => +new Date(codeMax.recordDate) <= +new Date(d.recordDate)).reduce((min, d) => {
          if (min) {
            const a = new Date(min);
            const b = new Date(d);
            const e = new Date(codeMax.recordDate);

            return getTimeDiff(e, a, 'days') > getTimeDiff(e, b, 'days') ? d : min;
          }

          return d;
        }, null);

        pData?.push({ ...closest, recordDate: codeMax.recordDate });
      }
    });

    pData = pData?.filter(d => +d.recordDate >= +codeMax.recordDate);
  }

  // exp = this.evalSqaureBrackets(dateWiseData, Object.keys(tickers), exp);

  // forEach(Object.keys(dateWiseData), key => {

  // });

  let prevVals = [];

  dataArr.dataKeys.forEach(key => {
    let items = dataArr.data[key];
    let expression = exp && exp.selectedBreak ? exp.selectedBreak : exp;

    if (items.length !== tickers.length) {
      const dateItems = [];

      tickers.forEach((ticker, index) => {
        let item = items.find(d => d.code.toUpperCase() === ticker.toUpperCase());

        if (!item) item = prevVals.find(d => d.code.toUpperCase() === ticker.toUpperCase());

        if (item) dateItems[index] = item;
      });

      items = dateItems.length > 0 ? dateItems : items;
    }

    items.forEach(item => {
      if (item && item.code && isDefined(item.value)) {
        expression = expression.toUpperCase().replace(new RegExp(formulaUtil.getCodeSymbolEscape(item.code.replace(/[|]/g, '[|]')).toUpperCase(), 'g'), item.value);
      }
    });

    if (!regX.test(expression)) {
      expression = +parseFloat(eval(expression));
      plottedData.push({ key: getKey(key, type), data: expression });
    }

    prevVals = items.filter(d => d !== undefined);
    // }
  });

  plottedData = orderBy(plottedData, item => item?.key);

  return plottedData;
};

// const setSymbolCode = data => data.map(item => ({ ...item, symbolCode: `${item.ticker}.${item.code}` }));

export default (expression, data, selectedView = 'Max') => {
  const resultSeries = [];
  // const exprs = expression.toUpperCase().split(';');
  let toPlotdata = [];

  // data = {
  //     ...data,
  //     series_data: setSymbolCode(data.series_data, 'seriesCode'),
  //     stock_data: setSymbolCode(data.stock_data, 'price_type')
  // };

  const isDaily = selectedView === '1D';

  if (!isDaily) {
    switch (data.chart_type) {
      case dataConstants.CHART_TYPE.SEQUENCE:
        toPlotdata = data.sequenceData;
        break;
      case dataConstants.CHART_TYPE.CATEGORIES:
      case dataConstants.CHART_TYPE.PIECATEGORY:
        return data.sequenceData.length && data.sequenceData.length > 0
          ? data.series.map(d => ({
            seq: d.seq,
            data: data.sequenceData
              .filter(it => it.code === d.yformula && it.desc)
              .map(item => ({ key: item.seq, data: item.value, desc: item.desc })),
          }))
          : //  [{ seq: 1, data: data.sequenceData.map(item => ({ key: item.seq, data: item.value, desc: item.desc })) }]
          [];
      case dataConstants.CHART_TYPE.TIMESERIES:
      case dataConstants.CHART_TYPE.LIFESTORY:
        toPlotdata = data.dataProp === 'series_data' ? data.stock_data.concat(getPlotDataPoints(data, selectedView || 'max')) : data.series_data?.concat(getPlotDataPoints(data, selectedView || 'Max'));
        break;
      case dataConstants.CHART_TYPE.PIETIME:
        toPlotdata = data.dataProp === 'series_data' ? data.stock_data.concat(getPlotDataPoints(data, selectedView || 'max')) : data.series_data?.concat(getPlotDataPoints(data, selectedView || 'Max'));
        const maxItem = toPlotdata.max('recordDate');
        //toPlotdata = toPlotdata.filter()
        toPlotdata = toPlotdata.filter(d => +new Date(d.recordDate) === +new Date(maxItem.recordDate))
        toPlotdata = uniqBy(toPlotdata, 'code');
        toPlotdata = data.series.map(d => {
          let desc = d.yformula;
          const derivedData = evalExpression(d.yformula, toPlotdata, data);
          const codes = formulaUtil.getSymbolCodes(d.yformula);

          codes.forEach((c, i) => {
            const item = toPlotdata.find(n => n.code === c);
            desc = item && item.desc ? desc.replace(new RegExp(c, 'g'), item.desc) : desc;
          });

          return {
            ...(derivedData && derivedData.length > 0 ? derivedData[0] : {}),
            desc,
            yformula: d.yformula,
          };
        });
        //toPlotdata = toPlotdata.map(d => ({key: d.recordDate, data: d.value, desc: d.desc, code: d.code}));
        return [{ seq: 1, data: toPlotdata }];
      case dataConstants.CHART_TYPE.STACKED:
        toPlotdata = data.stock_data.concat(data.series_data);
        break;
      default:
        toPlotdata = [];
    }
  } else {
    return data.dailyStockData && data.dailyStockData.length > 0
      ? [{ seq: 1, data: getTradingData(data.dailyStockData).map(item => ({ key: new Date(item.recordDate), data: item.value })) }]
      : [];
  }

  //  = data.chart_type === dataConstants.CHART_TYPE.SEQUENCE ? data.sequenceData : data.series_data.concat(data.stock_data);

  // toPlotdata = setSymbolCode(toPlotdata);

  data?.series?.forEach((series, index) => {
    // const series = data.series.find(item => item.yformula.toUpperCase() === exp.toUpperCase());
    const codes = formulaUtil.getSymbolCodes(series.yformula);
    const formulaData = toPlotdata?.filter(d => codes?.includes(d?.code));
    const expData = evalExpression(series?.yformula, formulaData, data, data?.chart_type);

    if (expData.length > 0) resultSeries.push({ seq: series?.seq, data: expData });
  });

  return resultSeries;
};



// const getArrKeys = (data, type = dataConstants.CHART_TYPE.TIMESERIES) => {
//   if (type === dataConstants.CHART_TYPE.TIMESERIES || type === dataConstants.CHART_TYPE.LIFESTORY || type === dataConstants.CHART_TYPE.STACKED) {
//     const dateWiseData = groupBy(data, item => item.recordDate);
//     const dates = Object.keys(dateWiseData).sort((a, b) => new Date(a) - new Date(b));
//     return { data: dateWiseData, dataKeys: dates };
//   }
//   const seqWiseData = groupBy(data, item => item.seq);
//   const seqs = Object.keys(seqWiseData).sort((a, b) => a - b);

//   return { data: seqWiseData, dataKeys: seqs };
// };

// const getKey = (key, type = dataConstants.CHART_TYPE.TIMESERIES) =>
//   type === dataConstants.CHART_TYPE.TIMESERIES || type === dataConstants.CHART_TYPE.LIFESTORY || type === dataConstants.CHART_TYPE.STACKED ? new Date(key) : +key;

// export const evalExpression = (exp, data, chart = {}, type) => {
//   // let dateWiseData = groupBy(data, item => item.recordDate);
//   // let dates = Object.keys(dateWiseData).sort((a, b) => new Date(a) - new Date(b));
//   let pData = data;
//   const codeWiseData = groupBy(pData, it => it.code);



//   const dataArr = getArrKeys(pData, type);

//   let plottedData = [];
//   const reg = /[A-Za-z\[\]]+/;
//   const regX = new RegExp(reg);
//   let squareItems = formulaUtil.getSquareItems(exp);

//   if (squareItems && squareItems.length > 0) {
//     squareItems = squareItems.map(d => {
//       const item = codeWiseData && Object.keys(codeWiseData).length > 0 ? codeWiseData[d.code].find(it => (+it['recordDate'] || it['seq']) === +getKey(d.key, type)) : null;
//       return ({ ...d, value: item ? item.value : null });
//     });

//     squareItems = squareItems.filter(d => d.value);

//     squareItems.forEach(d => {
//       exp = exp.replace(new RegExp(d.item.replace(/\[/g, '\\[').replace(/\]/g, '\\]'), 'g'), d.value);
//     });
//   }

//   const tickers = formulaUtil.getSymbolCodes(exp, undefined, true);

//   if (type === dataConstants.CHART_TYPE.TIMESERIES || type === dataConstants.CHART_TYPE.LIFESTORY || type === dataConstants.CHART_TYPE.STACKED) {
//     pData = data && data.length && data.map(d => ({ ...d, recordDate: d.recordDate ? new Date(d.recordDate) : d.recordDate }));
//     let codeMax = [];

//     Object.keys(codeWiseData).forEach(c => {
//       const newCodeWiseData = codeWiseData[c];
//       // let minDate = newCodeWiseData.reduce((min, p) => p.recordDate < min ? p.recordDate : min, newCodeWiseData[0].recordDate);
//       // c && codeWiseData && codeMax.push(codeWiseData[c].min('recordDate'));
//       c && codeWiseData && codeMax.push(newCodeWiseData.find(d => d.recordDate === newCodeWiseData.reduce((min, p) => p.recordDate < min ? p.recordDate : min, newCodeWiseData[0].recordDate)));

//     });

//     // let maxDate = codeMax.reduce((max, p) => p.recordDate > max ? p.recordDate : max, codeMax[0].recordDate);
//     // codeMax = codeMax.max('recordDate');
//     codeMax = codeMax.find(d => d.recordDate === codeMax.reduce((max, p) => p.recordDate > max ? p.recordDate : max, codeMax[0].recordDate));

//     Object.keys(codeWiseData).forEach(c => {
//       if (c !== codeMax.code) {
//         const closest = codeWiseData[c].filter(d => +new Date(codeMax.recordDate) <= +new Date(d.recordDate)).reduce((min, d) => {
//           if (min) {
//             const a = new Date(min);
//             const b = new Date(d);
//             const e = new Date(codeMax.recordDate);

//             return getTimeDiff(e, a, 'days') > getTimeDiff(e, b, 'days') ? d : min;
//           }

//           return d;
//         }, null);

//         pData.push({ ...closest, recordDate: codeMax.recordDate });
//       }
//     });

//     pData = pData && pData.filter(d => +d.recordDate >= +codeMax.recordDate);
//   }

//   // exp = this.evalSqaureBrackets(dateWiseData, Object.keys(tickers), exp);

//   // forEach(Object.keys(dateWiseData), key => {

//   // });

//   let prevVals = [];

//   dataArr.dataKeys.forEach(key => {
//     let items = dataArr.data[key];
//     let expression = exp;

//     if (items.length !== tickers.length) {
//       const dateItems = [];

//       tickers.forEach((ticker, index) => {
//         let item = items.find(d => d.code.toUpperCase() === ticker.toUpperCase());

//         if (!item) item = prevVals.find(d => d.code.toUpperCase() === ticker.toUpperCase());

//         if (item) dateItems[index] = item;
//       });

//       items = dateItems.length > 0 ? dateItems : items;
//     }

//     items.forEach(item => {
//       if (item && item.code && isDefined(item.value)) {
//         expression = expression.toUpperCase().replace(new RegExp(formulaUtil.getCodeSymbolEscape(item.code.replace(/[|]/g, '[|]')).toUpperCase(), 'g'), item.value);
//       }
//     });

//     if (!regX.test(expression)) {
//       expression = +parseFloat(eval(expression));
//       plottedData.push({ key: getKey(key, type), data: expression });
//     }

//     prevVals = items.filter(d => d !== undefined);
//     // }
//   });

//   plottedData = orderBy(plottedData, item => item.key);

//   return plottedData;
// };

// // const setSymbolCode = data => data.chartProps.map(item => ({ ...item, symbolCode: `${item.ticker}.${item.code}` }));

// export default (expression, data, selectedView = 'Max') => {
//   const resultSeries = [];
//   // const exprs = expression.toUpperCase().split(';');
//   let toPlotdata = [];
//   // data = {
//   //     ...data,
//   //     series_data: setSymbolCode(data.chartProps.series_data, 'seriesCode'),
//   //     stock_data: setSymbolCode(data.chartProps.stock_data, 'price_type')
//   // };

//   const isDaily = selectedView === '1D';

//   if (!isDaily) {
//     switch (data.chartProps.chart_type) {
//       case dataConstants.CHART_TYPE.SEQUENCE:
//         toPlotdata = data.chartProps.sequenceData;
//         break;
//       case dataConstants.CHART_TYPE.CATEGORIES:
//       case dataConstants.CHART_TYPE.PIECATEGORY:
//         return data.chartProps.sequenceData.length && data.chartProps.sequenceData.length > 0
//           ? data.chartProps.series.map(d => ({
//             seq: d.seq,
//             data: data.chartProps.sequenceData
//               .filter(it => it.code === d.yformula && it.desc)
//               .map(item => ({ key: item.seq, data: item.value, desc: item.desc })),
//           }))
//           : //  [{ seq: 1, data: data.chartProps.sequenceData.map(item => ({ key: item.seq, data: item.value, desc: item.desc })) }]
//           [];
//       case dataConstants.CHART_TYPE.TIMESERIES:
//       case dataConstants.CHART_TYPE.LIFESTORY:
//         toPlotdata = data.chartProps.dataProp === 'series_data' ? data.chartProps.stock_data.concat(getPlotDataPoints(data, selectedView || 'max')) : data.chartProps.series_data.concat(getPlotDataPoints(data, selectedView || 'Max'));
//         break;
//       case dataConstants.CHART_TYPE.PIETIME:
//         toPlotdata = data.chartProps.dataProp === 'series_data' ? data.chartProps.stock_data.concat(getPlotDataPoints(data, selectedView || 'max')) : data.chartProps.series_data.concat(getPlotDataPoints(data, selectedView || 'Max'));
//         const maxItem = toPlotdata.max('recordDate');
//         //toPlotdata = toPlotdata.filter()
//         toPlotdata = toPlotdata.filter(d => +new Date(d.recordDate) === +new Date(maxItem.recordDate))
//         toPlotdata = uniqBy(toPlotdata, 'code');
//         toPlotdata = data.chartProps.series.map(d => {
//           let desc = d.yformula;
//           const derivedData = evalExpression(d.yformula, toPlotdata, data);
//           const codes = formulaUtil.getSymbolCodes(d.yformula);

//           codes.forEach((c, i) => {
//             const item = toPlotdata.find(n => n.code === c);
//             desc = item.desc ? desc.replace(new RegExp(c, 'g'), item.desc) : desc;
//           });

//           return {
//             ...(derivedData && derivedData.length > 0 ? derivedData[0] : {}),
//             desc,
//             yformula: d.yformula,
//           };
//         });
//         //toPlotdata = toPlotdata.map(d => ({key: d.recordDate, data: d.value, desc: d.desc, code: d.code}));
//         return [{ seq: 1, data: toPlotdata }];
//       case dataConstants.CHART_TYPE.STACKED:
//         toPlotdata = data.chartProps.stock_data.concat(data.chartProps.series_data);
//         break;
//       default:
//         toPlotdata = [];
//     }
//   } else {
//     return data.chartProps.dailyStockData && data.chartProps.dailyStockData.length > 0
//       ? [{ seq: 1, data: getTradingData(data.chartProps.dailyStockData).map(item => ({ key: new Date(item.recordDate), data: item.value })) }]
//       : [];
//   }

//   //  = data.chartProps.chart_type === dataConstants.CHART_TYPE.SEQUENCE ? data.chartProps.sequenceData : data.chartProps.series_data.concat(data.chartProps.stock_data);

//   // toPlotdata = setSymbolCode(toPlotdata);
//   data && data.chartProps.series && data.chartProps.series.forEach((series, index) => {
//     // const series = data.chartProps.series.find(item => item.yformula.toUpperCase() === exp.toUpperCase());
//     const codes = formulaUtil.getSymbolCodes(series.yformula);
//     // const formulaData = toPlotdata.filter(d => codes.includes(d.code));
//     const formulaData = toPlotdata && toPlotdata.filter(d => d && d.code === codes[0]);
//     const expData = evalExpression(series.yformula, formulaData, data, data.chartProps.chart_type);

//     if (expData.length > 0) resultSeries.push({ seq: series.seq, data: expData });
//   });

//   return resultSeries;
// };
